import { render, staticRenderFns } from "./assetFreeze.vue?vue&type=template&id=46d1c064"
import script from "./assetFreeze.vue?vue&type=script&lang=js"
export * from "./assetFreeze.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports